export interface Item {
  id: number;
  name: string;
  code: string;
  image?: string;
  section_ids: number[];
  active?: boolean;
  images?: object;
}

export interface Section {
  id: number;
  name: string;
  top_sec_id: number | null;
  image?: string;
}

export type PaneType = 'left' | 'right';

export interface CatalogState {
  activePane: PaneType;
  leftPane: PaneState;
  rightPane: PaneState;
  expandedSections: Set<number>;
  itemSectionLookup: Map<number, Set<number>>;
  sectionChildren: Map<number | null, number[]>;
  historyStack: HistoryEntry[];
}

export interface PaneState {
  selectedSectionId: number | null;
  markedItemIds: Set<number>;
  currentRootSectionId: number | null; // The section being viewed as root
  navigationVersion: number; // Increments on each navigation to force pagination reset
}

export interface ItemCreatedEvent {
  item: Item;
}

export interface ItemUpdatedEvent {
  item: Item;
}

export interface ItemMovedEvent {
  itemId: number;
  fromSectionId: number;
  toSectionId: number;
}

export interface SectionCreatedEvent {
  section: Section;
}

export interface SectionUpdatedEvent {
  section: Section;
}

export interface SectionDeletedEvent {
  sectionId: number;
}

export type HistoryActionType = 
  | 'item_created'
  | 'item_updated'
  | 'item_moved'
  | 'item_deleted'
  | 'section_created'
  | 'section_updated'
  | 'section_deleted'
  | 'section_parent_changed';

export interface HistoryEntry {
  type: HistoryActionType;
  timestamp: number;
  description: string;
  undoData: any;
}

export interface ChangesSavedEvent {
  changes?: HistoryEntry[];
  data?: CatalogData;
}

// Special section ID for items with no section
export const UNSECTIONED_ITEMS_ID = -1;

// New input/output data structure
export interface ItemData {
  id: number;
  name: string;
  code: string;
  images: object;
  mainImageUrl?: string | null;
  active?: boolean;
  removed?: boolean;
}

export interface SectionData {
  id: number;
  name: string;
  mainImageUrl?: string | null;
  parentSectionId: number | null;
  removed?: boolean;
}

export interface CatalogData {
  items: { [key: string]: ItemData };
  sections: { [key: string]: SectionData };
  itemToSections: { [key: string]: number[] };
}
